<template>
  <component class="icon" v-bind:is="this.icon"></component>
</template>

<script>
import iconProducts from "@/assets/icons/products";
import upload from "@/assets/icons/upload";
import document from "@/assets/icons/document";
import settings from "@/assets/icons/settings";
import searchCheck from "@/assets/icons/searchCheck";
import register from "@/assets/icons/register";
import publish from "@/assets/icons/publish";
import caretUp from "@/assets/icons/caret-up";
import caretDown from "@/assets/icons/caret-down";

export default {
  name: "icons",
  components: {
    iconProducts,
    upload,
    document,
    settings,
    searchCheck,
    publish,
    register,
    caretUp,
    caretDown
  },
  props: {
      icon: { type: String, required: true }
  }
}
</script>